import { usePageHeader } from "contexts/PageHeaderContext";
import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { InputFieldset } from 'ui/inputFieldset';
import { SelectFieldset } from 'ui/selectFieldset';
import { SelectTriggerUI } from 'ui/selectTrigger';
import { Label } from '../../ui/label';
import { TextareaUI } from 'ui/textareaUI';
import { Badge } from '../../ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../ui/table';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '../../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectValue,
} from '../../ui/select';
import { ShieldAlert, Search, Eye, Calendar, User, Check, Filter, X, Clock, AlertCircle, Shield } from 'lucide-react';
import { toast } from 'sonner';

interface BlockSchedule {
  id: string;
  fromDate: string;
  toDate: string;
  blockedVenues: string[];
  remarks: string;
  status: 'active' | 'expired';
  blockedBy: string;
  blockedDate: string;
}

interface BlockedUser {
  id: string;
  itsId: string;
  userName: string;
  dateOfBirth: string;
  officeName: string;
  email: string;
  ownerItsId?: string;
  ownerName?: string;
  userType: 'Tour Operator' | 'Partner' | 'Member' | 'Staff';
  status: 'Active' | 'Block Listed';
  blockSchedules: BlockSchedule[];
}

interface BlockUsersMasterPageProps {
  onNavigate?: (page: string) => void;
}

// Available venues list
// const AVAILABLE_VENUES = [
//   { id: 'karbala', name: 'Karbala' },
//   { id: 'najaf', name: 'Najaf' },
//   { id: 'baghdad', name: 'Baghdad' },
//   { id: 'kufa', name: 'Kufa' },
//   { id: 'samarra', name: 'Samarra' },
//   { id: 'kadhimiya', name: 'Kadhimiya' },
// ];

export const BlockUsersMasterPage = ({ onNavigate }: BlockUsersMasterPageProps) => {
  const { setPageHeader } = usePageHeader();
  useEffect(() => {
    setPageHeader({
      title: "Blocked Users",
      childTitle: "Manage user access and block schedules",
      icon: <ShieldAlert className="h-5 w-5" />,
    });
    return () => setPageHeader(null);
  }, [setPageHeader]);

  const [users, setUsers] = useState<BlockedUser[]>([
    {
      id: '1',
      itsId: '60453129',
      userName: 'Qutbuddin Akkarsali Kanchiwala',
      dateOfBirth: '18-11-1969',
      officeName: 'Khoj Tours And Travels',
      email: 'info@khojtours.com',
      ownerItsId: '20420134',
      ownerName: 'Moiz bhai Mohammeddali bhai Bhammal',
      userType: 'Partner',
      status: 'Active',
      blockSchedules: [
        {
          id: 'bs-old-1',
          fromDate: '2023-03-01',
          toDate: '2023-05-31',
          blockedVenues: ['Karbala'],
          remarks: 'First offense - Late payment and documentation delay',
          status: 'expired',
          blockedBy: 'Admin (Ahmed Raza)',
          blockedDate: '2023-02-28'
        },
        {
          id: 'bs-old-2',
          fromDate: '2024-01-15',
          toDate: '2024-03-15',
          blockedVenues: ['Najaf', 'Baghdad'],
          remarks: 'Second offense - Multiple customer complaints regarding service quality',
          status: 'expired',
          blockedBy: 'Admin (Fatima Khan)',
          blockedDate: '2024-01-10'
        }
      ],
    },
    {
      id: '2',
      itsId: '60457649',
      userName: 'User 4',
      dateOfBirth: '18-01-2003',
      officeName: 'Fayz E Husayni Trust Mumbai',
      email: 'faremavadgamewala23@gmail.com',
      ownerItsId: '20349163',
      ownerName: 'Fayz E Husayni Trust Mumbai',
      userType: 'Partner',
      status: 'Active',
      blockSchedules: [],
    },
    {
      id: '3',
      itsId: '60462302',
      userName: 'Mulla Zaakir bhai Taherali bhai Rampurawala',
      dateOfBirth: '07-07-1961',
      officeName: 'Burhani tours and travels',
      email: 'tahir.zaakir52@gmail.com',
      userType: 'Tour Operator',
      status: 'Active',
      blockSchedules: [
        {
          id: 'bs-old-3',
          fromDate: '2022-08-01',
          toDate: '2022-09-30',
          blockedVenues: ['Samarra', 'Kadhimiya'],
          remarks: 'Temporary block due to license renewal pending',
          status: 'expired',
          blockedBy: 'Admin (Syed Ali)',
          blockedDate: '2022-07-28'
        }
      ],
    },
    {
      id: '4',
      itsId: '78652045',
      userName: 'Ahmed Hassan Mohammad',
      dateOfBirth: '15-03-1985',
      officeName: 'Baghdad Travel Services',
      email: 'ahmed@baghdadtravel.com',
      userType: 'Tour Operator',
      status: 'Block Listed',
      blockSchedules: [
        {
          id: 'bs1',
          fromDate: '2025-01-01',
          toDate: '2025-06-30',
          blockedVenues: ['Karbala', 'Najaf'],
          remarks: 'Payment issues and multiple complaints',
          status: 'active',
          blockedBy: 'Admin (Syed Ali)',
          blockedDate: '2024-12-15'
        },
        {
          id: 'bs2',
          fromDate: '2024-06-01',
          toDate: '2024-08-31',
          blockedVenues: ['Baghdad'],
          remarks: 'Temporary suspension due to documentation issues',
          status: 'expired',
          blockedBy: 'Admin (Fatima Khan)',
          blockedDate: '2024-05-20'
        },
        {
          id: 'bs3',
          fromDate: '2023-11-01',
          toDate: '2024-01-31',
          blockedVenues: ['Kufa', 'Najaf'],
          remarks: 'Customer safety violations and unauthorized tour modifications',
          status: 'expired',
          blockedBy: 'Admin (Ahmed Raza)',
          blockedDate: '2023-10-28'
        }
      ],
    },
    {
      id: '5',
      itsId: '60458923',
      userName: 'Fatima Zahra Husaini',
      dateOfBirth: '22-05-1978',
      officeName: 'Al Zahra Tours & Services',
      email: 'info@alzahratours.com',
      userType: 'Tour Operator',
      status: 'Block Listed',
      blockSchedules: [
        {
          id: 'bs-5-1',
          fromDate: '2024-12-01',
          toDate: '2025-03-31',
          blockedVenues: ['Karbala', 'Najaf', 'Baghdad'],
          remarks: 'Repeated violations - Overcharging customers and providing misleading information',
          status: 'active',
          blockedBy: 'Admin (Syed Ali)',
          blockedDate: '2024-11-28'
        },
        {
          id: 'bs-5-2',
          fromDate: '2024-03-01',
          toDate: '2024-05-31',
          blockedVenues: ['Baghdad', 'Samarra'],
          remarks: 'License verification pending',
          status: 'expired',
          blockedBy: 'Admin (Fatima Khan)',
          blockedDate: '2024-02-25'
        },
        {
          id: 'bs-5-3',
          fromDate: '2023-07-15',
          toDate: '2023-09-15',
          blockedVenues: ['Najaf'],
          remarks: 'First warning - Late submission of required documents',
          status: 'expired',
          blockedBy: 'Admin (Ahmed Raza)',
          blockedDate: '2023-07-10'
        }
      ],
    },
    {
      id: '6',
      itsId: '60451234',
      userName: 'Mohammad Ali Jafari',
      dateOfBirth: '10-09-1982',
      officeName: 'Ziyarat Express Services',
      email: 'contact@ziyaratexpress.com',
      userType: 'Partner',
      status: 'Active',
      blockSchedules: [
        {
          id: 'bs-6-1',
          fromDate: '2024-08-01',
          toDate: '2024-09-30',
          blockedVenues: ['Karbala'],
          remarks: 'Short-term suspension for staff training and quality improvement',
          status: 'expired',
          blockedBy: 'Admin (Fatima Khan)',
          blockedDate: '2024-07-28'
        },
        {
          id: 'bs-6-2',
          fromDate: '2023-12-01',
          toDate: '2024-01-15',
          blockedVenues: ['Baghdad', 'Kufa'],
          remarks: 'Holiday season overload - Temporary capacity restrictions',
          status: 'expired',
          blockedBy: 'Admin (Ahmed Raza)',
          blockedDate: '2023-11-29'
        }
      ],
    },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showViewDialog, setShowViewDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState<BlockedUser | null>(null);
  const [showStatistics] = useState(false);
  const [showUnblockDialog, setShowUnblockDialog] = useState(false);
  const [userToUnblock, setUserToUnblock] = useState<string | null>(null);

  // Advanced Filter States (matching Venue Master)
  const [filters, setFilters] = useState({
    itsId: '',
    userName: '',
    officeName: '',
    status: 'all',
    userType: 'all',
  });

  const [blockFormData, setBlockFormData] = useState({
    fromDate: '',
    toDate: '',
    remarks: '',
    selectedVenues: [] as string[]
  });

  const filteredUsers = users.filter(user => {
    // Search term filter
    const matchesSearch =
      user.itsId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.officeName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase());

    // Advanced filters
    const matchesItsId = !filters.itsId || user.itsId.includes(filters.itsId);
    const matchesUserName = !filters.userName || user.userName.toLowerCase().includes(filters.userName.toLowerCase());
    const matchesOfficeName = !filters.officeName || user.officeName.toLowerCase().includes(filters.officeName.toLowerCase());
    const matchesStatus = filters.status === 'all' || user.status === filters.status;
    const matchesUserType = filters.userType === 'all' || user.userType === filters.userType;

    return matchesSearch && matchesItsId && matchesUserName && matchesOfficeName && matchesStatus && matchesUserType;
  });

  // Helper function to get user display status based on active block schedules
  const getUserStatus = (user: BlockedUser): 'Active' | 'Block Listed' => {
    const hasActiveBlock = user.blockSchedules.some(schedule => schedule.status === 'active');
    return hasActiveBlock ? 'Block Listed' : 'Active';
  };

  const handleClearFilters = () => {
    setFilters({
      itsId: '',
      userName: '',
      officeName: '',
      status: 'all',
      userType: 'all',
    });
  };

  const handleBlockUser = (user: BlockedUser) => {
    setSelectedUser(user);
    setBlockFormData({
      fromDate: '',
      toDate: '',
      remarks: '',
      selectedVenues: []
    });
    setShowDialog(true);
  };

  const handleViewUser = (user: BlockedUser) => {
    setSelectedUser(user);
    setShowViewDialog(true);
  };

  // const handleVenueToggle = (venueId: string) => {
  //   setBlockFormData(prev => ({
  //     ...prev,
  //     selectedVenues: prev.selectedVenues.includes(venueId)
  //       ? prev.selectedVenues.filter(v => v !== venueId)
  //       : [...prev.selectedVenues, venueId]
  //   }));
  // };

  const handleSaveBlock = () => {
    if (!selectedUser || !blockFormData.fromDate || !blockFormData.toDate) {
      toast.error('Please fill all required fields');
      return;
    }

    const newBlockSchedule: BlockSchedule = {
      id: Date.now().toString(),
      fromDate: blockFormData.fromDate,
      toDate: blockFormData.toDate,
      blockedVenues: [],
      remarks: blockFormData.remarks,
      status: 'active',
      blockedBy: 'Admin (Current User)',
      blockedDate: new Date().toISOString().split('T')[0]
    };

    setUsers(users.map(u =>
      u.id === selectedUser.id
        ? {
          ...u,
          status: 'Block Listed',
          blockSchedules: [...u.blockSchedules, newBlockSchedule]
        }
        : u
    ));

    toast.success('User blocked successfully');
    setShowDialog(false);
    setSelectedUser(null);
  };

  const handleUnblockUser = (userId: string) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm('Are you sure you want to unblock this user?')) {
      setUsers(users.map(u =>
        u.id === userId ? { ...u, status: 'Active', blockSchedules: [] } : u
      ));
      toast.success('User unblocked successfully');
    }
  };

  const getUserTypeColor = (type: string) => {
    const colors: Record<string, string> = {
      'Tour Operator': 'bg-blue-100 text-blue-700 border-blue-300',
      'Partner': 'bg-purple-100 text-purple-700 border-purple-300',
      'Member': 'bg-green-100 text-green-700 border-green-300',
      'Staff': 'bg-orange-100 text-orange-700 border-orange-300'
    };
    return colors[type] || 'bg-gray-100 text-gray-700 border-gray-300';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 via-white to-blue-50">
      <div className="p-4 sm:p-6 lg:p-8 max-w-[1400px] mx-auto">
        {/* Page Header */}


        {/* Statistics Cards */}
        {showStatistics && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <Card className="border-blue-200 bg-blue-50/50">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-blue-600">Total Users</p>
                    <p className="text-2xl font-bold text-blue-900">{users.length}</p>
                  </div>
                  <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
                    <User className="w-6 h-6 text-blue-600" />
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-green-200 bg-green-50/50">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-green-600">Active Users</p>
                    <p className="text-2xl font-bold text-green-900">
                      {users.filter(u => u.status === 'Active').length}
                    </p>
                  </div>
                  <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
                    <Check className="w-6 h-6 text-green-600" />
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-red-200 bg-red-50/50">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-red-600">Blocked Users</p>
                    <p className="text-2xl font-bold text-red-900">
                      {users.filter(u => u.status === 'Block Listed').length}
                    </p>
                  </div>
                  <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                    <Shield className="w-6 h-6 text-red-600" />
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-amber-200 bg-amber-50/50">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm text-amber-600">Tour Operators</p>
                    <p className="text-2xl font-bold text-amber-900">
                      {users.filter(u => u.userType === 'Tour Operator').length}
                    </p>
                  </div>
                  <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
                    <User className="w-6 h-6 text-amber-600" />
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        )}

        {/* Search Bar and Filter Toggle */}
        <Card className="border-[#5B9BD5]/30">
          <CardContent className="p-4">
            <div className="flex gap-3">
              <div className="flex-1 relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <Input
                  placeholder="Search by ITS ID, name, office, or email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
              <Button
                variant={showFilters ? "default" : "outline"}
                size="icon"
                onClick={() => setShowFilters(!showFilters)}
                style={showFilters ? { background: '#5B9BD5' } : {}}
                className={showFilters ? "text-white" : "border-[#5B9BD5] text-[#5B9BD5] hover:bg-sky-50"}
                title="Toggle Advanced Filters"
              >
                <Filter className="w-5 h-5" />
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Advanced Filters Section (Venue Master Style) */}
        {showFilters && (
          <Card className="border-[#5B9BD5]/30 bg-gradient-to-br from-sky-50/50 to-blue-50/50 mt-4">
            <CardHeader className="pb-3">
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle style={{ color: '#5B9BD5' }} className="flex items-center gap-2 text-lg">
                    <Filter className="w-5 h-5" />
                    Advanced Filters
                  </CardTitle>
                  <CardDescription className="mt-1">
                    Filter users by multiple criteria
                  </CardDescription>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setShowFilters(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="w-4 h-4" />
                </Button>
              </div>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {/* ITS ID Filter */}
                <div className="space-y-2">
                  <InputFieldset
                    label="ITS ID"
                    id="filter-its-id"
                    placeholder="Search by ITS ID..."
                    value={filters.itsId}
                    onChange={(e) => setFilters({ ...filters, itsId: e.target.value })}
                    className="font-mono text-sm"
                  />
                </div>

                {/* User Name Filter */}
                <div className="space-y-2">
                  <InputFieldset 
                    label="User Name"
                    id="filter-user-name"
                    placeholder="Search by user name..."
                    value={filters.userName}
                    onChange={(e) => setFilters({ ...filters, userName: e.target.value })}
                    className="text-sm"
                  />
                </div>

                {/* Office Name Filter */}
                <div className="space-y-2">
                  <InputFieldset
                    label="Office Name"
                    id="filter-office-name"
                    placeholder="Search by office name..."
                    value={filters.officeName}
                    onChange={(e) => setFilters({ ...filters, officeName: e.target.value })}
                    className="text-sm"
                  />
                </div>

                {/* Status Filter */}
                <div className="space-y-2">
                  <SelectFieldset label="Status">
                    <Select
                      value={filters.status}
                      onValueChange={(value) => setFilters({ ...filters, status: value })}
                    >
                      <SelectTriggerUI id="filter-status" className="text-sm">
                        <SelectValue />
                      </SelectTriggerUI>
                      <SelectContent>
                        <SelectItem value="all">All Status</SelectItem>
                        <SelectItem value="Active">Active Only</SelectItem>
                        <SelectItem value="Block Listed">Blocked Only</SelectItem>
                      </SelectContent>
                    </Select>
                  </SelectFieldset>
                </div>

                {/* User Type Filter */}
                <div className="space-y-2">
                  <SelectFieldset label="User Type">
                    <Select
                      value={filters.userType}
                      onValueChange={(value) => setFilters({ ...filters, userType: value })}
                    >
                      <SelectTriggerUI id="filter-user-type" className="text-sm">
                        <SelectValue />
                      </SelectTriggerUI>
                      <SelectContent>
                        <SelectItem value="all">All Types</SelectItem>
                        <SelectItem value="Tour Operator">Tour Operator</SelectItem>
                        <SelectItem value="Partner">Partner</SelectItem>
                        <SelectItem value="Member">Member</SelectItem>
                        <SelectItem value="Staff">Staff</SelectItem>
                      </SelectContent>
                    </Select>
                  </SelectFieldset>
                </div>
              </div>

              {/* Active Filters Summary & Clear Button (Venue Master Style) */}
              {(filters.itsId || filters.userName || filters.officeName || filters.status !== 'all' || filters.userType !== 'all') && (
                <div className="flex items-center justify-between gap-3 p-3 bg-white border border-[#5B9BD5]/30 rounded-lg">
                  <div className="flex-1">
                    <p className="text-sm font-medium text-[#5B9BD5] mb-2">Active Filters:</p>
                    <div className="flex flex-wrap gap-1.5">
                      {filters.itsId && (
                        <Badge variant="outline" className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs">
                          ITS: {filters.itsId}
                        </Badge>
                      )}
                      {filters.userName && (
                        <Badge variant="outline" className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs">
                          Name: {filters.userName}
                        </Badge>
                      )}
                      {filters.officeName && (
                        <Badge variant="outline" className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs">
                          Office: {filters.officeName}
                        </Badge>
                      )}
                      {filters.status !== 'all' && (
                        <Badge variant="outline" className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs">
                          Status: {filters.status}
                        </Badge>
                      )}
                      {filters.userType !== 'all' && (
                        <Badge variant="outline" className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs">
                          Type: {filters.userType}
                        </Badge>
                      )}
                    </div>
                  </div>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={handleClearFilters}
                    className="border-red-300 text-red-600 hover:bg-red-50 flex-shrink-0"
                  >
                    <X className="w-4 h-4 mr-1" />
                    Clear All
                  </Button>
                </div>
              )}
            </CardContent>
          </Card>
        )}

        {/* Table */}
        <Card className="border-[#5B9BD5]/30 mt-4">
          <CardHeader className="border-b bg-gradient-to-r from-sky-50 to-blue-50">
            <CardTitle style={{ color: '#5B9BD5' }}>Users</CardTitle>
            <CardDescription>
              {filteredUsers.length} user{filteredUsers.length !== 1 ? 's' : ''} found
            </CardDescription>
          </CardHeader>
          <CardContent className="p-0">
            {/* Desktop Table View */}
            <div className="hidden md:block overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow style={{ backgroundColor: '#E3F2FD' }}>
                    <TableHead style={{ color: '#5B9BD5' }} className="px-4 py-3 text-xs">ITS ID</TableHead>
                    <TableHead style={{ color: '#5B9BD5' }} className="px-4 py-3 text-xs">Name / Office</TableHead>
                    <TableHead style={{ color: '#5B9BD5' }} className="px-4 py-3 text-xs">User Type</TableHead>
                    <TableHead style={{ color: '#5B9BD5' }} className="px-4 py-3 text-xs">Email</TableHead>
                    <TableHead style={{ color: '#5B9BD5' }} className="px-4 py-3 text-xs">Status</TableHead>
                    <TableHead style={{ color: '#5B9BD5' }} className="px-4 py-3 text-xs text-right">Actions</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {filteredUsers.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} className="text-center py-8 px-4 text-gray-500 text-sm">
                        No users found
                      </TableCell>
                    </TableRow>
                  ) : (
                    filteredUsers.map((user) => (
                      <TableRow key={user.id} className="hover:bg-sky-50/30">
                        <TableCell className="px-4 py-3">
                          <Badge variant="outline" className="border-[#5B9BD5]/30 text-[#5B9BD5] font-mono text-[10px] px-1.5 py-0.5">
                            {user.itsId}
                          </Badge>
                        </TableCell>
                        <TableCell className="px-4 py-3">
                          <div className="flex flex-col gap-0.5">
                            <span className="text-sm text-gray-900">{user.userName}</span>
                            <span className="text-xs text-gray-500">{user.officeName}</span>
                          </div>
                        </TableCell>
                        <TableCell className="px-4 py-3">
                          <Badge className={`${getUserTypeColor(user.userType)} text-[10px] px-1.5 py-0.5`}>
                            {user.userType}
                          </Badge>
                        </TableCell>
                        <TableCell className="px-4 py-3">
                          <span className="text-xs text-gray-600">{user.email}</span>
                        </TableCell>
                        <TableCell className="px-4 py-3">
                          <Badge className={`${getUserStatus(user) === 'Active' ? 'bg-green-100 text-green-700 border-green-300' : 'bg-red-100 text-red-700 border-red-300'} text-[10px] px-1.5 py-0.5`}>
                            {getUserStatus(user)}
                          </Badge>
                        </TableCell>
                        <TableCell className="px-4 py-3 text-right">
                          <div className="flex items-center justify-end gap-1">
                            <Button
                              size="sm"
                              variant="ghost"
                              onClick={() => handleViewUser(user)}
                              className="text-[#5B9BD5] hover:bg-sky-50 h-7 w-7 p-0"
                              title="View details"
                            >
                              <Eye className="w-3.5 h-3.5" />
                            </Button>
                            {getUserStatus(user) === 'Active' ? (
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => handleBlockUser(user)}
                                className="text-red-600 hover:bg-red-50 h-7 px-2"
                                title="Block user"
                              >
                                <ShieldAlert className="w-3.5 h-3.5 mr-1" />
                                <span className="text-xs">Block</span>
                              </Button>
                            ) : (
                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() => {
                                  setUserToUnblock(user.id);
                                  setShowUnblockDialog(true);
                                }}
                                className="text-green-600 hover:bg-green-50 h-7 px-2"
                                title="Unblock user"
                              >
                                <Check className="w-3.5 h-3.5 mr-1" />
                                <span className="text-xs">Unblock</span>
                              </Button>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </div>

            {/* Mobile Card View */}
            <div className="md:hidden divide-y divide-gray-200">
              {filteredUsers.length === 0 ? (
                <div className="text-center py-8 px-4 text-gray-500 text-sm">
                  No users found
                </div>
              ) : (
                filteredUsers.map((user) => (
                  <div key={user.id} className="p-4 hover:bg-sky-50/30 transition-colors">
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 mb-1">
                          <Badge variant="outline" className="border-[#5B9BD5]/30 text-[#5B9BD5] font-mono text-[10px] px-1.5 py-0.5">
                            {user.itsId}
                          </Badge>
                          <Badge className={`${getUserStatus(user) === 'Active' ? 'bg-green-100 text-green-700 border-green-300' : 'bg-red-100 text-red-700 border-red-300'} text-[10px] px-1.5 py-0.5`}>
                            {getUserStatus(user)}
                          </Badge>
                        </div>
                        <h3 className="font-medium text-sm text-gray-900 mb-0.5">{user.userName}</h3>
                        <p className="text-xs text-gray-500 mb-2">{user.officeName}</p>
                        <div className="flex items-center gap-2 flex-wrap">
                          <Badge className={`${getUserTypeColor(user.userType)} text-[10px] px-1.5 py-0.5`}>
                            {user.userType}
                          </Badge>
                          <span className="text-xs text-gray-600">{user.email}</span>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center gap-2 pt-3 border-t border-gray-100">
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleViewUser(user)}
                        className="flex-1 text-[#5B9BD5] border-[#5B9BD5]/30 hover:bg-sky-50 h-8 text-xs"
                      >
                        <Eye className="w-3.5 h-3.5 mr-1.5" />
                        View
                      </Button>
                      {getUserStatus(user) === 'Active' ? (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => handleBlockUser(user)}
                          className="flex-1 text-red-600 border-red-200 hover:bg-red-50 h-8 text-xs"
                        >
                          <ShieldAlert className="w-3.5 h-3.5 mr-1.5" />
                          Block
                        </Button>
                      ) : (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => {
                            setUserToUnblock(user.id);
                            setShowUnblockDialog(true);
                          }}
                          className="flex-1 text-green-600 border-green-200 hover:bg-green-50 h-8 text-xs"
                        >
                          <Check className="w-3.5 h-3.5 mr-1.5" />
                          Unblock
                        </Button>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </CardContent>
        </Card>

        {/* Block User Dialog */}
        <Dialog open={showDialog} onOpenChange={setShowDialog}>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto sm:rounded-lg w-[calc(100vw-2rem)] sm:w-full">
            <DialogHeader>
              <DialogTitle style={{ color: '#5B9BD5' }} className="text-lg sm:text-xl">Block User</DialogTitle>
              <DialogDescription className="text-xs sm:text-sm">
                Block {selectedUser?.userName} (ITS: {selectedUser?.itsId})
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-4 py-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <InputFieldset
                    label="From Date"
                    required
                    id="fromDate"
                    type="date"
                    value={blockFormData.fromDate}
                    onChange={(e) => setBlockFormData({ ...blockFormData, fromDate: e.target.value })}
                    className="text-xs sm:text-sm"
                  />
                </div>

                <div className="space-y-2">
                  <InputFieldset
                    label="To Date"
                    required
                    id="toDate"
                    type="date"
                    value={blockFormData.toDate}
                    onChange={(e) => setBlockFormData({ ...blockFormData, toDate: e.target.value })}
                    className="text-xs sm:text-sm"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <SelectFieldset label="Remarks">
                  <TextareaUI
                    id="remarks"
                    placeholder="Reason for blocking..."
                    value={blockFormData.remarks}
                    onChange={(e) => setBlockFormData({ ...blockFormData, remarks: e.target.value })}
                    className="text-xs sm:text-sm min-h-[80px]"
                  />
                </SelectFieldset>
              </div>
            </div>

            <DialogFooter className="flex-col sm:flex-row gap-2 sm:gap-0">
              <Button variant="outline" onClick={() => setShowDialog(false)} className="text-xs sm:text-sm w-full sm:w-auto">
                Cancel
              </Button>
              <Button onClick={handleSaveBlock} className="bg-red-600 hover:bg-red-700 text-white text-xs sm:text-sm w-full sm:w-auto">
                Block User
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* View User Dialog */}
        <Dialog open={showViewDialog} onOpenChange={setShowViewDialog}>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto sm:rounded-lg w-[calc(100vw-2rem)] sm:w-full">
            <DialogHeader>
              <DialogTitle style={{ color: '#5B9BD5' }} className="text-lg sm:text-xl">User Details</DialogTitle>
              <DialogDescription className="text-xs sm:text-sm">
                View complete information and block history for this user
              </DialogDescription>
            </DialogHeader>

            {selectedUser && (
              <div className="space-y-4 py-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <InputFieldset
                      label="ITS ID"
                      id="itsId"
                      value={selectedUser?.itsId || "N/A"}
                      readOnly
                      disabled
                      tabIndex={-1}
                      className="bg-white border-gray-300 rounded-lg cursor-not-allowed pointer-events-none text-xs sm:text-sm font-medium"
                    />
                  </div>
                  <div>
                    <Label className="text-xs text-gray-500">User Type</Label>
                    <Badge className={`${getUserTypeColor(selectedUser.userType)} text-xs mt-1`}>
                      {selectedUser.userType}
                    </Badge>
                  </div>
                </div>

                <div>
                  <InputFieldset
                    label="Name"
                    id="userName"
                    value={selectedUser?.userName || "N/A"}
                    readOnly
                    disabled
                    tabIndex={-1}
                    className="bg-white border-gray-300 rounded-lg cursor-not-allowed pointer-events-none text-xs sm:text-sm font-medium"
                  />
                </div>

                <div>
                  <InputFieldset
                    label="Office Name"
                    id="officeName"
                    value={selectedUser?.officeName || "N/A"}
                    readOnly
                    disabled
                    tabIndex={-1}
                    className="bg-white border-gray-300 rounded-lg cursor-not-allowed pointer-events-none text-xs sm:text-sm"
                  />
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <InputFieldset
                      label="Email"
                      id="email"
                      value={selectedUser?.email}
                      readOnly
                      disabled
                      tabIndex={-1}
                      className="bg-white border-gray-300 rounded-lg cursor-not-allowed pointer-events-none text-xs sm:text-sm break-all"
                    />
                  </div>
                  <div>
                    <InputFieldset
                      label="Date of Birth"
                      id="dateOfBirth"
                      value={selectedUser?.dateOfBirth}
                      readOnly
                      disabled
                      tabIndex={-1}
                      className="bg-white border-gray-300 rounded-lg cursor-not-allowed pointer-events-none text-xs sm:text-sm"
                    />
                  </div>
                </div>

                {/* Activity Logs - Previous Block/Blacklist History */}
                <div className="space-y-2 pt-2 border-t border-gray-200">
                  <Label className="text-xs sm:text-sm flex items-center gap-2">
                    <Clock className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#5B9BD5]" />
                    Activity Logs - Previous Block/Blacklist History
                  </Label>
                  {selectedUser.blockSchedules.length > 0 ? (
                    <Card className="border-amber-200 bg-amber-50/30 max-h-64 overflow-y-auto">
                      <CardContent className="p-2.5 sm:p-3 space-y-2">
                        {selectedUser.blockSchedules.map((schedule, index) => (
                          <div key={schedule.id} className="border-b border-amber-200 last:border-0 pb-2 last:pb-0">
                            <div className="flex items-start justify-between mb-1 gap-2">
                              <div className="flex items-center gap-1.5 sm:gap-2 flex-wrap">
                                <Badge className={`${schedule.status === 'active' ? 'bg-red-100 text-red-700 border-red-300' : 'bg-gray-100 text-gray-700 border-gray-300'} text-[9px] sm:text-[10px]`}>
                                  {schedule.status}
                                </Badge>
                                <span className="text-[10px] sm:text-xs font-medium text-gray-700">
                                  Block #{selectedUser.blockSchedules.length - index}
                                </span>
                              </div>
                              <span className="text-[9px] sm:text-[10px] text-gray-500 flex-shrink-0">
                                {new Date(schedule.blockedDate).toLocaleDateString('en-US', {
                                  month: 'short',
                                  day: 'numeric',
                                  year: 'numeric'
                                })}
                              </span>
                            </div>
                            <div className="space-y-1">
                              <div className="flex items-start sm:items-center gap-2 flex-col sm:flex-row">
                                <p className="text-[10px] sm:text-xs text-gray-700">
                                  <Calendar className="w-2.5 h-2.5 sm:w-3 sm:h-3 inline mr-1" />
                                  <strong>Period:</strong> {new Date(schedule.fromDate).toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                  })} to {new Date(schedule.toDate).toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                  })}
                                </p>
                                <Badge className={`${schedule.status === 'active' ? 'bg-red-50 text-red-600 border-red-200' : 'bg-gray-50 text-gray-600 border-gray-200'} text-[8px] sm:text-[9px] px-1.5 py-0`}>
                                  {schedule.status.toUpperCase()}
                                </Badge>
                              </div>
                              {schedule.remarks && (
                                <p className="text-[10px] sm:text-xs text-gray-600 italic bg-white/50 p-1.5 rounded">
                                  <AlertCircle className="w-2.5 h-2.5 sm:w-3 sm:h-3 inline mr-1" />
                                  <strong>Reason:</strong> {schedule.remarks}
                                </p>
                              )}
                              <p className="text-[9px] sm:text-[10px] text-gray-500">
                                Blocked by: {schedule.blockedBy}
                              </p>
                            </div>
                          </div>
                        ))}
                      </CardContent>
                    </Card>
                  ) : (
                    <Card className="border-gray-200 bg-gray-50/30">
                      <CardContent className="p-3 sm:p-4">
                        <div className="flex items-center justify-center gap-2 text-gray-500">
                          <AlertCircle className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
                          <p className="text-xs sm:text-sm">No previous block or blacklist activity found</p>
                        </div>
                      </CardContent>
                    </Card>
                  )}
                  <p className="text-[9px] sm:text-[10px] text-gray-500 italic">
                    Complete history of all blocking activities for this user
                  </p>
                </div>
              </div>
            )}

            <DialogFooter>
              <Button variant="outline" onClick={() => setShowViewDialog(false)} className="text-xs sm:text-sm w-full sm:w-auto">
                Close
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Unblock User Dialog */}
        <Dialog open={showUnblockDialog} onOpenChange={setShowUnblockDialog}>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto sm:rounded-lg w-[calc(100vw-2rem)] sm:w-full">
            <DialogHeader>
              <DialogTitle style={{ color: '#5B9BD5' }} className="text-lg sm:text-xl">Unblock User</DialogTitle>
              <DialogDescription className="text-xs sm:text-sm">
                Unblock user with ITS ID: {userToUnblock}
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-4 py-4">
              <p className="text-xs sm:text-sm text-gray-700">
                Are you sure you want to unblock this user? This action will remove all block schedules and restore their access.
              </p>
            </div>

            <DialogFooter className="flex-col sm:flex-row gap-2 sm:gap-0">
              <Button variant="outline" onClick={() => setShowUnblockDialog(false)} className="text-xs sm:text-sm w-full sm:w-auto">
                Cancel
              </Button>
              <Button
                onClick={() => {
                  if (userToUnblock) {
                    handleUnblockUser(userToUnblock);
                  }
                  setShowUnblockDialog(false);
                }}
                className="bg-green-600 hover:bg-green-700 text-white text-xs sm:text-sm w-full sm:w-auto"
              >
                Unblock User
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};